// Unanswered (undefined) and "No" (false) mean the same thing for opt-in
// office flags, so switching between them is not a change and must not force
// an effective-date history entry.
const OPT_IN_OFFICE_FLAGS = ["heatIsPurchased"];

const isOfficeFieldChanged = (field, originalValue, value) => {
  // Must run before the falsy-value guard below: undefined is a falsy,
  // non-false value, so a true -> undefined transition (opted-in, now
  // cleared without an explicit "No") needs this check first to be caught
  // as changed, the same as the true -> false transition already is.
  if (OPT_IN_OFFICE_FLAGS.includes(field)) {
    return (originalValue === true) !== (value === true);
  }

  if (!value && value !== false) {
    return false;
  }

  if (field === "facilityType") {
    return originalValue?.value !== value.value;
  }

  return originalValue !== value;
};

// Fields the office editor treats as edited, comparing the working copy to
// the office as it was opened.
export const findChangedOfficeFields = (originalOffice = {}, modifyOffice = {}) =>
  Object.entries(modifyOffice)
    .filter(([field, value]) =>
      isOfficeFieldChanged(field, originalOffice[field], value)
    )
    .map(([field]) => field);
